/**
 * Get the pairing id in all lowercase withought spaces, colons or dashes
 * to compare for equality with other pairing ids.
 *
 * Example:
 * AABB11223344 => aabb11223344
 * AA:BB:11:22:33:44 => aabb11223344
 * AA-BB-11-22-33-44 => aabb11223344
 */
export const getCleanMacAddressPairingId = (pairingId: string): string => {
  return pairingId.toLowerCase().replaceAll(/[\s:-]/g, '')
}
